import {
  PipelineGraphData,
  PipelineLocationsData,
  PipelinesData,
  StatusDetailsData,
} from '@/types';
import {
  Core,
  PIPELINES,
  PIPELINES_GRAPH,
  PIPELINES_LOCATIONS,
  PIPELINES_STATUS,
} from '../Core';

class Pipelines extends Core {
  getPipelines = async (locationId?: string) =>
    this.get<PipelinesData>(PIPELINES(locationId));

  getLocations = async () =>
    this.get<PipelineLocationsData>(PIPELINES_LOCATIONS());

  getGraph = async () => this.get<PipelineGraphData>(PIPELINES_GRAPH());

  getStatuses = async (locationId?: string) =>
    this.get<StatusDetailsData>(PIPELINES_STATUS(locationId));
}

export const pipelines = new Pipelines();
